import $ from 'jquery'

var settings = {
  title: 'title',
  content: 'content',
  width: 200,
  height: 100,
}

$.fn.jqTip = function (options) {
  var target = $(this)
  options = $.extend(true, settings, options || settings)
  var tipDialog = $('<div></div>').addClass('jq-tip-dialog')
  var title = $('<h1>' + options.title + '</h1>')
  var content = $('<div></div>')
    .html(options.content)
    .addClass('jq-tip-content')
  var contentArea = $('<div></div>')
    .width(options.width)
    .height(options.height)
    .append(content)
  var wrapper = $('<div></div>').addClass('wrapper').append(contentArea)
  tipDialog.append(title).append(wrapper)
  $('body').append(tipDialog)
  target.bind({
    mousemove: function (e) {
      tipDialog.css({
        left: e.pageX + 15,
        top: e.pageY + 15,
        display: 'block',
      })
    },
    mouseleave: function () {
      tipDialog.css('display', 'none')
    },
  })
}

$(document).ready(function () {
  dhsv_vc_single_image()
})

function dhsv_vc_single_image() {
  var title = $('#single-img-id').attr('data-title')
  var text = $('#single-img-id').attr('data-text')
  if (title != '' && text != '') {
    $('#single-img-id').jqTip({
      title: title,
      content: text,
      height: 'auto',
      width: 300,
    })
  }
}
